import React from "react";
import { Link, useNavigate } from "react-router-dom";
import QuantusLogo from "../assets/img/Quantus-Invoice.png";
import QuantusMark from "../assets/img/Quantus-Invoice3.png";

function NotFound() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <main className="relative min-h-screen w-full overflow-hidden bg-sirius-night flex items-center justify-center px-4 py-12">
      {/* Layered brand backdrop */}
      <div className="absolute inset-0 bg-sirius-mesh opacity-50" />
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />
      <div className="pointer-events-none absolute -top-32 -left-24 w-[28rem] h-[28rem] rounded-full bg-spark-500/25 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 w-[26rem] h-[26rem] rounded-full bg-sirius-600/30 blur-[120px]" />

      {/* Top-left brand lockup */}
      <header className="absolute top-6 left-6 sm:top-8 sm:left-8 z-10 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white shadow-spark">
          <img
            src={QuantusMark}
            alt="Quantus Invoice"
            className="h-8 w-8 object-contain"
          />
        </div>
        <div className="leading-tight">
          <img
            src={QuantusLogo}
            alt="Quantus Invoice"
            className="h-5 w-auto object-contain"
          />
          <p className="mt-1 text-[10px] tracking-wide text-white/40">
            A Sirius Solutions product
          </p>
        </div>
      </header>

      {/* Center card */}
      <section className="relative z-10 w-full max-w-[30rem] animate-sirius-fade-up">
        <div className="glass-panel rounded-2xl shadow-sirius-lg px-8 py-12 sm:px-12 sm:py-14 text-center">
          <span className="sirius-badge inline-flex items-center gap-2">
            <i className="fas fa-triangle-exclamation text-spark-500" aria-hidden="true" />
            Error 404
          </span>

          <div className="relative mt-7 flex items-center justify-center">
            <div
              className="pointer-events-none absolute h-40 w-40 rounded-full bg-spark-500/20 blur-3xl animate-sirius-pulse"
              aria-hidden="true"
            />
            <h1 className="relative font-display text-7xl sm:text-8xl font-bold leading-none tracking-tight text-gradient-sirius">
              404
            </h1>
          </div>

          <h2 className="mt-6 font-display text-2xl sm:text-3xl font-semibold text-white">
            Página no encontrada
          </h2>

          <p className="mx-auto mt-4 max-w-sm text-sm leading-relaxed text-white/55">
            La ruta que intentas abrir no existe o fue movida. Utiliza las
            opciones siguientes para continuar de forma segura.
          </p>

          {/* Action row */}
          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={() => navigate("/dashboard")}
              className="sirius-btn-primary inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-spark-500/60 w-full sm:w-auto"
            >
              <i className="fas fa-gauge" aria-hidden="true" />
              Volver al panel
            </button>

            <Link
              to="/login"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10 hover:border-white/20 focus:outline-none focus:ring-2 focus:ring-spark-500/60 w-full sm:w-auto"
            >
              <i className="fas fa-right-to-bracket" aria-hidden="true" />
              Ir a iniciar sesión
            </Link>
          </div>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mt-6 inline-flex items-center gap-2 text-xs font-medium text-white/45 transition-colors hover:text-white/75 focus:outline-none focus:ring-2 focus:ring-spark-500/60 rounded"
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
            Volver atrás
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="absolute bottom-6 left-0 right-0 z-10 text-center text-xs text-white/35">
        © {currentYear} Sirius Solutions. Todos los derechos reservados.
      </footer>
    </main>
  );
}

export default NotFound;
